<template lang="html">
  <v-container grid-list-md text-xs-center>
    <b-row>
      <b-col> 
        <label for="answer" class="mb-3 title-smiley" xs12 v-html="question.title" style="text-align: justify; "></label>
      </b-col>
    </b-row>
    <b-row v-if="order === 'right'">
      <div class="smiley-col">
          <img :src="'/static/smileys/default/1.png'" :class="{'smiley': true, 'is-gray': disableSmiley('1')}" @click="changeStepAuto() ; getValue('1')">
          <p class = "mt-2" style="flex-wrap: nowrap">{{smileyTitle('1')}} </p>
      </div>
      <div class="smiley-col">
          <img :src="'/static/smileys/default/2.png'" :class="{'smiley': true, 'is-gray': disableSmiley('2')}" @click="changeStepAuto() ; getValue('2')">
          <p class = "mt-2">{{smileyTitle('2')}} </p>
      </div>
      <div class="smiley-col">
          <img :src="'/static/smileys/default/3.png'" :class="{'smiley': true, 'is-gray': disableSmiley('3')}" @click="changeStepAuto() ; getValue('3')">
          <p class = "mt-2">{{smileyTitle('3')}} </p>
      </div>
      <div class="smiley-col">
          <img :src="'/static/smileys/default/4.png'" :class="{'smiley': true, 'is-gray': disableSmiley('4')}" @click="changeStepAuto() ; getValue('4')">
          <p class = "mt-2">{{smileyTitle('4')}} </p>
      </div>
      <div class="smiley-col">
          <img :src="'/static/smileys/default/5.png'" :class="{'smiley': true, 'is-gray': disableSmiley('5')}" @click="changeStepAuto() ; getValue('5')">
          <p class = "mt-2">{{smileyTitle('5')}} </p>
      </div>
    </b-row>
    <b-row v-if="order === 'left'">
      <div class="smiley-col">
          <img :src="'/static/smileys/default/5.png'" :class="{'smiley': true, 'is-gray': disableSmiley('5')}" @click="changeStepAuto() ; getValue('5')" >
          <p class = "mt-2">{{smileyTitle('5')}} </p>
      </div>
      <div class="smiley-col">
          <img :src="'/static/smileys/default/4.png'" :class="{'smiley': true, 'is-gray': disableSmiley('4')}" @click="changeStepAuto() ; getValue('4')">
          <p class = "mt-2">{{smileyTitle('4')}} </p>
      </div>
      <div class="smiley-col">
          <img :src="'/static/smileys/default/3.png'" :class="{'smiley': true, 'is-gray': disableSmiley('3')}" @click="changeStepAuto() ; getValue('3')">
          <p class = "mt-2">{{smileyTitle('3')}} </p>
      </div>
      <div class="smiley-col">
          <img :src="'/static/smileys/default/2.png'" :class="{'smiley': true, 'is-gray': disableSmiley('2')}" @click="changeStepAuto() ; getValue('2')">
          <p class = "mt-2">{{smileyTitle('2')}} </p>
      </div>
      <div class="smiley-col">
          <img :src="'/static/smileys/default/1.png'" :class="{'smiley': true, 'is-gray': disableSmiley('1')}" @click="changeStepAuto() ; getValue('1')">
          <p class = "mt-2">{{smileyTitle('1')}} </p>
      </div>
    </b-row>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    question: {
      type: Object,
      required: true
    },
    order: {
      type: String,
      default: 'right'
    },
  },
  data () {
    return {
      order_selected: this.order,
    };
  },
  computed: {
    
  },
  mounted () {
    if (this.question.value) {
      this.getValue(this.question.value);
    }
  },
  methods: {
    smileyTitle: function (data) {      
      if (data === '1') {
        return this.question.options.length > 0 ? this.question.options[4].title : 'Very bad';
      } else if (data === '2') {
        return this.question.options.length > 0 ? this.question.options[3].title : 'Bad';
      } else if (data === '3') {
        return this.question.options.length > 0 ? this.question.options[2].title : 'Neutral';
      } else if (data === '4') {
        return this.question.options.length > 0 ? this.question.options[1].title : 'Good';
      } else {
        return this.question.options.length > 0 ? this.question.options[0].title : 'Excellent';
      }
    },
    getValue: function (value) {
      this.question.value = value;
    },
    disableSmiley: function (value) {
      if (this.question.value === null || this.question.value === value) {
        return false;
      }
      return true;
    },
    changeStepAuto: function () {
      this.$emit('change-step-auto');
    } 
  },

};
</script>

<style lang="css">
.title-smiley{
  font-size: 20px;
  font-weight: bold;
  padding-left: 4px;
  margin-left: 8px;
}
.smiley {
  width: 100%;
  cursor: pointer;
}
.smiley-col {
  width: 20%;
  padding: 4px;
}
label{
  font-size: 20px;
}
.is-gray {
  filter: grayscale(95%);
}
@media screen and (max-width: 768px){
  p{
    font-size: 11px;
  }
  
}
@media only screen and (max-width: 600px) {
  .smiley {
    width: 100%;
    cursor: pointer;
  }
}
@media only screen and (orientation: portrait) and (max-width: 475px)  {
  .title-smiley {
    font-size: 16px;
    font-weight: bold;
    padding-left: 4px;
    margin-left: 8px;
  }
}
</style>


// WEBPACK FOOTER //
// src/surveys/components/Smiley.vue